class HxntrSlider {
    constructor(slider) {

        this.slider = slider;
        this.track = slider.querySelector(".slider-track");
        this.prev = slider.querySelector(".slider-prev");
        this.next = slider.querySelector(".slider-next");

        if (!this.track) return;

        this.isDown = false;
        this.startX = 0;
        this.scrollLeft = 0;

        this.cardWidth = () => {

            const card = this.track.querySelector(".fresh-card");

            if (!card) return 340;

            const gap = parseInt(getComputedStyle(this.track).gap) || 24;

            return card.offsetWidth + gap;

        };

        this.prev?.addEventListener("click", () => {

            this.track.scrollBy({
                left: -this.cardWidth(),
                behavior: "smooth"
            });

        });

        this.next?.addEventListener("click", () => {

            this.track.scrollBy({
                left: this.cardWidth(),
                behavior: "smooth"
            });

        });

        /* Drag */

        this.track.addEventListener("mousedown", (e) => {

            this.isDown = true;

            this.track.classList.add("dragging");

            this.startX = e.pageX;

            this.scrollLeft = this.track.scrollLeft;

        });

        window.addEventListener("mouseup", () => {

            this.isDown = false;

            this.track.classList.remove("dragging");

        });

        this.track.addEventListener("mouseleave", () => {

            this.isDown = false;

            this.track.classList.remove("dragging");

        });

        this.track.addEventListener("mousemove", (e) => {

            if (!this.isDown) return;

            e.preventDefault();

            const walk = (e.pageX - this.startX) * 1.4;

            this.track.scrollLeft = this.scrollLeft - walk;

        });

    }

}

document.addEventListener("DOMContentLoaded", () => {

    document.querySelectorAll(".hxntr-slider").forEach(slider => {

        new HxntrSlider(slider);

    });

});